import { render, staticRenderFns } from "./refresh-route-cache.vue?vue&type=template&id=b8c98f88&"
import script from "./refresh-route-cache.vue?vue&type=script&lang=js&"
export * from "./refresh-route-cache.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports